type Props = {
  countdown: string | null
  textationOverride?: string
}

export function CodeExpirationCountdown({
  countdown,
  textationOverride,
}: Props) {
  if (!countdown) return null

  return (
    <span>
      {textationOverride ?? 'Platnosť kódu'}:&nbsp;
      <strong
        translate="no"
        data-countdown={countdown}
        className="after:content-[attr(data-countdown)]"
      />
    </span>
  )
}
